import { v4 as uuid } from 'uuid';

import { IPatient, Admission, v2, constants } from '../../..';
import { getDefaults } from './helpers/getDefaults';

export const admissionAdapter = (patient: IPatient): v2.Admission => {
    const {
        admission,
        referralDateTime,
        referralPathway,
        referredBy,
        referrer,
        systmOneRef,
    } = patient;

    const defaults = getDefaults(patient);

    const { admittedBy, admittedAt, dischargedBy, dischargedAt, isAdmitted } = admission || {};

    const admissionStatuses: v2.AdmissionStatus[] = [];

    const createAdmissionStatus = (
        confirmedBy: string,
        confirmedAt: string,
        statusTypeId: string,
    ) => {
        admissionStatuses.push({
            ...getDefaults(patient),
            id: uuid(),
            admissionId: constants.NOT_CAPTURED,
            statusTypeId,
            createdAt: new Date(confirmedAt),
            confirmedAt: new Date(confirmedAt),
            updatedAt: null,
            createdById: confirmedBy,
            confirmedBy,
            updatedById: null,
            status: {
                ...getDefaults(patient),
                name: statusTypeId,
                isDischarged: statusTypeId === Admission.DISCHARGED,
                isDefault: false,
                unitId: constants.NOT_CAPTURED,
                id: constants.NOT_CAPTURED,
            },
        });
    };

    if (dischargedAt && dischargedBy && !isAdmitted) {
        createAdmissionStatus(dischargedBy, dischargedAt, Admission.DISCHARGED);
    }

    if (admittedAt && admittedBy) {
        createAdmissionStatus(admittedBy, admittedAt, Admission.ADMITTED);
    }

    return {
        ...defaults,
        id: uuid(),
        patientId: constants.NOT_CAPTURED,
        referralDateTime: referralDateTime ? new Date(referralDateTime) : null,
        referralPathway,
        referredBy,
        referrer,
        systmOneRef,
        admissionStatuses,
    };
};
